export default __webpack_public_path__ + "static/media/28.e93c24d9.png";